<!-- * Operations form -->
<form [formGroup]="addOperationForm" (ngSubmit)="onAddOperation()">
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !addOperationForm.valid }"
        [disabled]="!addOperationForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj operaciju</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Oznaka operacije</label>
            <input type="text" formControlName="label" pInputText />
            <span></span>
          </div>

          <div class="field">
            <label>Naziv operacije</label>
            <input type="text" formControlName="name" pInputText />
          </div>
          <div class="field">
            <label>Koeficijent</label>
            <input type="text" formControlName="coefficient" pInputText />
          </div>
        </div>
      </div>

      <div class="grid">
        <div class="col-12 mt-4">
          <h3>Dodaj podoperacije</h3>
        </div>
        <div class="col-12">
          <section
            formArrayName="suboperations"
            *ngFor="let suboperation of getControls(); let i = index"
          >
            <div class="card-border mb-3" [formGroupName]="i">
              <h4 class="mb-3">{{ i + 1 }}. Podoperacija</h4>
              <section class="flex align-items-center justify-content-between">
                <div class="flex flex-wrap">
                  <div class="field mr-3">
                    <label>Oznaka podoperacije</label>
                    <input type="text" formControlName="label" pInputText />
                  </div>

                  <div class="field mr-3">
                    <label>Naziv podoperacije</label>
                    <input type="text" formControlName="name" pInputText />
                  </div>

                  <div class="field mr-3">
                    <label>Cena rada</label>
                    <input type="text" formControlName="cost" pInputText />
                  </div>
                </div>

                <button
                  class="second-btn small-btn"
                  type="button"
                  pTooltip="Izbriši"
                  tooltipPosition="top"
                  (click)="removeSuboperation(i)"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </section>
            </div>
          </section>

          <button
            class="second-btn mt-3"
            type="button"
            (click)="addSuboperation()"
          >
            Dodaj podoperaciju
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
